
<template>
  <Dropdown
    filter
    unstyled
    :disabled="disabled"
    showClear
    :pt="{
      root: ({ state }) => ({
        class: [
          'rounded px-2 py-1 flex flex-row items-center gap-x-1 w-full',
          disabled ? disabledClass:'bg-white dark:bg-slate-700',
          state.focused ? focusClass:'',
          transitionClass,
          paddingClass,
          borderClass,
          textClass,
        ]
      }),
      item: ({ context }) => ({
        class: [
          textClass,
          'px-2 py-[2px] transition-all last:rounded-b min-h-[1.25rem]',
          context.selected ? 'bg-theme/20 hover:bg-theme/40':'hover:bg-gray-500/10'
        ]
      }),
      input: ({ props }) => ({
        class: [
          'outline-0 w-full truncate',
          props.modelValue ? '':placeHolderClass
        ]
      }),
      panel: {
        class: panelClass
      },
      filterContainer: {
        class: [
          'flex flex-row items-center gap-x-1 p-2 w-full'
        ]
      },
      filterInput: {
        class: [
          'rounded outline-0 w-full px-2 py-1 dark:bg-slate-600',
          borderClass
        ]
      },
    }"
  >
    <template #empty>
      <div :class="emptyText ? 'w-full text-center p-2':''">
        {{ emptyText }}
      </div>
    </template>
  </Dropdown>
</template>


<script>

  import Dropdown from 'primevue/dropdown';

  export default {
    name: "RpmSelectInput",
    components: {
      Dropdown
    },
    props: {
      disabled: {
        type: Boolean,
        default: false
      },
      transitionClass: {
        type: String,
        default: ''
      },
      placeHolderClass: {
        type: String,
        default: ''
      },
      focusClass: {
        type: String,
        default: ''
      },
      borderClass: {
        type: String,
        default: ''
      },
      textClass: {
        type: String,
        default: ''
      },
      disabledClass: {
        type: String,
        default: ''
      },
      paddingClass: {
        type: String,
        default: ''
      },
      panelClass: {
        type: String,
        default: ''
      },
      emptyText: {
        type: String,
        default: ''
      },
    }
  };

</script>
